<app-wa-table
  [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers" [isDataLoading]="false"
  [areMoreData]="false" (loadMore)="loadMore()" [data]="matches" (headerClick)="changeSort($event)"
>
<ng-template [extraClass]="['nowrap','wa-table__cell--fit-left' ]" app-column let-match >
    <ng-container *ngIf="getSelfAthlete as selfAthlete">
        <lib-athlete-name [color]="match.WinLose === false ? '#a7a7a7' : undefined" [id]="selfAthlete.Id" [gname]="selfAthlete.GName" [wnameord]="selfAthlete.WNameOrd" [fname]="selfAthlete.FName"></lib-athlete-name>
    </ng-container>
</ng-template>
<ng-template [extraClass]="['wa-table__cell--fit-left']" app-column  let-match>
  <div>-</div>
</ng-template>
<ng-template [extraClass]="['td-46']" app-column let-match >
    <ng-container>
        <lib-athlete-name [color]="match.WinLose === true ? '#a7a7a7' : undefined" [id]="match.Athlete.Id" [gname]="match.Athlete.GName" [wnameord]="match.Athlete.WNameOrd" [fname]="match.Athlete.FName"></lib-athlete-name>
        <lib-country-flag [id]="match.Athlete.NOC"></lib-country-flag>
      </ng-container>
</ng-template>
<ng-template [extraClass]="['nowrap']" app-column let-match >
  <ng-container>
    <div class="uppertext-no-viewport">{{match.PhaseName}}</div>
    </ng-container>
</ng-template>
<ng-template [extraClass]="['nowrap','wa-table__cell--fit-right']" app-column let-match >
    <ng-container>

        <app-win-loss-event [winLoss]="match.WinLose" [selfPoints]="match.Score" [otherPoints]="match.ScoreOpponent"></app-win-loss-event>

      </ng-container>
</ng-template>
<ng-template app-column-responsive let-match [extraClass]="['wa-table__cell--fit']">
<div>
    <ng-container *ngIf="getSelfAthlete as selfAthlete">
        <lib-athlete-name [color]="match.WinLose === false ? '#a7a7a7' : undefined" [id]="selfAthlete.Id" [gname]="selfAthlete.GName" [wnameord]="selfAthlete.WNameOrd" [fname]="selfAthlete.FName"></lib-athlete-name>

    </ng-container>

</div>
<div>
    <lib-athlete-name [color]="match.WinLose === true ? '#a7a7a7' : undefined" [id]="match.Athlete.Id" [gname]="match.Athlete.GName" [wnameord]="match.Athlete.WNameOrd" [fname]="match.Athlete.FName"></lib-athlete-name>
    <lib-country-flag [id]="match.Athlete.NOC"></lib-country-flag>
</div>
<div>
  <div class="uppertext-no-viewport">{{'PHASE' | transloco}}: <span>{{match.PhaseName}}</span></div>

</div>
<div>

</div>

</ng-template>
<ng-template app-column-responsive let-match [extraClass]="['nowrap', 'wa-table__cell--fit-right']">
    <ng-container>

        <app-win-loss-event [winLoss]="match.WinLose" [selfPoints]="match.Score" [otherPoints]="match.ScoreOpponent"></app-win-loss-event>

      </ng-container>
</ng-template>
</app-wa-table>
